module.exports = __webpack_public_path__ + "img/banner_aboutus.534d7387.png";